module.exports = __webpack_public_path__ + "img/main.15c69340.jpg";